import { appSignals } from "@cayo/shared/components/App/utils";
import { showError } from "@cayo/shared/components/App/utils/showError";
import { buildResultDialogScheme } from "@cayo/shared/components/AppRoots/ResultDialogScheme/buildResultDialogScheme";
import { asyncRequestPoolingService } from "@cayo/shared/services/asyncRequestPooling.service";
import { objectUtils } from "@cayo/shared/utils/object";
import { IActionHandlerParams } from "../types";

export const showResult = (actionId: string, parameters?: IActionHandlerParams) => {
  if (parameters?.response) {
    const items = parameters.response.commandExecutionResultSet || parameters.response.results;
    if (parameters.response.requestId) {
      // TODO: send alert
      asyncRequestPoolingService.send("startPooling", parameters.response);
      return;
    }

    if (parameters.response.status === "success") {
      if (items?.length) {
        const results = objectUtils.convertKeysToCamelCase(items);
        const resultScheme = buildResultDialogScheme(results);

        appSignals.send("showForm", { form: { ...resultScheme } as any });
      } else {
        // TODO: send success alert
      }
    } else if (parameters.response.errorMessage) {
      showError(parameters.response.errorMessage);
    } else {
      showError("Unknown error");
    }
  }
};
